// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHONE_VERIFICATION_CALL_ME_CODE = "Zavolaj mi a nadiktuj k\u00f3d";
export const PHONE_VERIFICATION_CHANGE_NUMBER_BTN = "zme\u0148";
export const PHONE_VERIFICATION_CONTACTING_YOU_ON_number_change = "na \u010d\u00edslo %(number)s (%(change)s).";
export const PHONE_VERIFICATION_COUNTRY_PREFIX = "Predvo\u013eba krajiny";
export const PHONE_VERIFICATION_EXPLANATION_FREE = "\u00faplne zadarmo";
export const PHONE_VERIFICATION_I_HAVE_FOREIGN_PHONE_NUMBER = "M\u00e1m zahrani\u010dn\u00e9 \u010d\u00edslo";
export const PHONE_VERIFICATION_I_HAVE_LOCAL_PHONE_NUMBER = "M\u00e1m slovensk\u00e9 \u010d\u00edslo";
export const PHONE_VERIFICATION_SEND_ME_CODE = "Po\u0161li mi k\u00f3d";
export const PHONE_VERIFICATION_TOKEN_CALL_LABEL = "Overovac\u00ed k\u00f3d z telefon\u00e1tu:";
export const PHONE_VERIFICATION_TOKEN_NOT_RECEIVED_RESEND_CALL = "K\u00f3d nem\u00e1m, zavolaj mi znovu.";
export const PHONE_VERIFICATION_TOKEN_NOT_RECEIVED_RESEND_SMS = "K\u00f3d nepri\u0161iel, po\u0161li znovu.";
export const PHONE_VERIFICATION_TOKEN_SMS_LABEL = "Overovac\u00ed k\u00f3d z SMS:";
export const PHONE_VERIFICATION_VALIDATE_TOKEN = "Over m\u00f4j k\u00f3d";
export const PHONE_VERIFICATION_WE_SENT_YOU_TOKEN_CALL = "Vol\u00e1me ti a nadiktujeme overovac\u00ed k\u00f3d";
export const PHONE_VERIFICATION_WE_SENT_YOU_TOKEN_SMS = "Poslali sme ti nov\u00fd overovac\u00ed k\u00f3d.";
export const PHONE_VERIFICATION_YOUR_LOCAL_PHONE_NUMBER = "Tvoje slovensk\u00e9 \u010d\u00edslo (09xx xxx xxx)";
export const PHONE_VERIFICATION_YOUR_MOBILE_NUMBER = "Tvoje mobiln\u00e9 \u010d\u00edslo";
